var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"text has-text-centered"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }